import React, { useEffect, useState } from 'react';
import { decode } from 'ent';
import InlineSvg from './InlineSvg';
import Link from './Link';
import { stripTags } from '../helpers/common';

const SearchResult = (props) => {
  const { hit } = props;

  const [ancestor, setAncestor] = useState(null);

  useEffect(() => {
    setAncestor(hit?._source?.ancestors?.nodes?.pop()?.title);
  }, [hit?._source?.ancestors?.nodes]);

  function formatDate(inputDate) {
    const date = new Date(inputDate);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  return (
    <div className="search-results__result">
      {hit?._source?.contentTypeName === 'document' ? (
        <>
          <a
            className="document-tile"
            href={hit?._source?.uri}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="document-tile__title-group">
              <div className="document-tile__icon">
                <InlineSvg color="brand-secondary" name="pdf" />
              </div>
              <span
                className="document-tile__link"
                target="_blank"
                rel="noopener noreferrer"
                dangerouslySetInnerHTML={{
                  __html: hit?._source?.title,
                }}
              />
            </div>
            <div className="document-tile__content">
              <div className="document-tile__meta">
                {hit?._source?.fileExtension ? (
                  <span>{hit?._source?.fileExtension}</span>
                ) : null}
                {hit?._source?.fileSize ? (
                  <span>
                    {(hit?._source?.fileSize / 1000000).toFixed(1)}
                    MB
                  </span>
                ) : null}
              </div>
            </div>
          </a>
        </>
      ) : (
        <div className="search-results__content-group">
          {ancestor && (
            <span className="search-results__label">{ancestor}</span>
          )}

          {hit?._source?.contentTypeName === 'post' && (
            <div className="search-results__meta">
              <span className="search-results__meta-date">{formatDate(hit?._source?.date)}</span>
            </div>
          )}

          <h4 className="search-results__title">
            <Link
              to={hit?._source?.uri}
              dangerouslySetInnerHTML={{
                __html: decode(hit?._source?.title),
              }}
            />
          </h4>

          {hit?._source?.excerpt && (
            <div className="search-results__excerpt">
              <span
                dangerouslySetInnerHTML={{
                  __html: stripTags(hit?._source?.excerpt),
                }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchResult;
